import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { apiData } from '@/lib/api';
import { formatPhone } from '@/lib/format';
import type { SiteInfo } from '@/types';

/**
 * 공개 푸터 — 사업자 정보 표기 (전자상거래 표시 의무, PG·본인인증 심사 요건).
 * 값은 관리자 콘솔(정산 탭)의 공급자 정보에서 온다 — 배포 없이 수정 가능.
 */
export function SiteFooter() {
  const { data } = useQuery({
    queryKey: ['site-info'],
    queryFn: () => apiData<SiteInfo>('/site-info'),
    staleTime: 10 * 60_000,
  });
  const supplier = data?.supplier;

  return (
    <footer className="mt-10 border-t border-line pb-8 pt-5 text-center text-xs leading-relaxed text-ink-sub">
      <nav className="mb-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <Link to="/terms" className="underline">
          이용약관
        </Link>
        <Link to="/terms#refund" className="underline">
          환불 정책
        </Link>
        <Link to="/privacy" className="underline">
          개인정보 처리방침
        </Link>
        <Link to="/pricing" className="underline">
          요금 안내
        </Link>
        <Link to="/verify" className="underline">
          문서 진위 확인
        </Link>
      </nav>
      {supplier?.name && (
        <p>
          {supplier.name}
          {supplier.representative ? ` · 대표 ${supplier.representative}` : ''}
          {supplier.registrationNo ? ` · 사업자등록번호 ${supplier.registrationNo}` : ''}
          <br />
          {supplier.address ?? ''}
          {supplier.phone ? ` · 전화 ${formatPhone(supplier.phone)}` : ''}
        </p>
      )}
    </footer>
  );
}
